<template>
  <div>
    <div class="header-single header-aquario">
      <div class="container  h-100">
        <div class="row align-items-end  h-100">
          <div class="col-sm ">
            <h1 class="align-bottom">{{ $t('peixesAquarioInstitucional.titulo') }}</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="container pt-5">
      <div class="row mb-2">
        <div class="col-md-4 p-3 ">

          <p class="mt-5">{{ $t('peixesAquarioInstitucional.paragrafo1') }}</p>

          <p>{{ $t('peixesAquarioInstitucional.paragrafo2') }}</p>

        </div>
        <div class="col-md-4 p-3">

          <p class="mt-5">{{ $t('peixesAquarioInstitucional.paragrafo3') }}</p>

          <p>{{ $t('peixesAquarioInstitucional.paragrafo4') }}</p>

          <ul>
            <li><a href="https://www.aquaa3.com.br/peixes-ornamentais-ameacam-biodiversidade/" target="_blank">{{ $t('peixesAquarioInstitucional.marcador1') }}</a></li>
            <li><a href="https://institutohorus.org.br/wp-content/uploads/2019/03/2016-FATMA-Pets-ornamentais-pesca-desportiva-low-res.pdf" target="_blank">{{ $t('peixesAquarioInstitucional.marcador2') }}</a></li>
            <li><a href="../../../assets/institucional/img/2009-Magalhaes-A.L.B.-Ciencia-Hoje-Peixes-de-aquario.pdf" target="_blank">{{ $t('peixesAquarioInstitucional.marcador3') }}</a></li>
          </ul>

        </div>
        <div class="col-md-4 p-3">
          <!-- galeria -->
            <div id="carousel-especies" class="carousel slide" data-bs-ride="carousel">
              <div class="carousel-inner">
                <div class="carousel-item active">
                  <img src="../../../assets/institucional/img/galeria/galeria-aquario-1.jpg" class="d-block w-100" alt="...">
                  <div class="carousel-caption d-none d-md-block">
                    <p class="text-start">
                      {{ $t('peixesAquarioInstitucional.paragrafo5') }}<br>{{ $t('peixesAquarioInstitucional.paragrafo5b') }}
                    </p>
                  </div>
                </div>
                <div class="carousel-item ">
                  <img src="../../../assets/institucional/img/galeria/galeria-aquario-2.jpg" class="d-block w-100" alt="...">
                  <div class="carousel-caption d-none d-md-block">
                    <p class="text-start">
                      {{ $t('peixesAquarioInstitucional.paragrafo6') }}<br>{{ $t('peixesAquarioInstitucional.paragrafo6b') }}
                    </p>
                  </div>
                </div>
                <div class="carousel-item ">
                  <img src="../../../assets/institucional/img/galeria/galeria-aquario-3.jpg" class="d-block w-100" alt="...">
                  <div class="carousel-caption d-none d-md-block">
                    <p class="text-start">
                      {{ $t('peixesAquarioInstitucional.paragrafo7') }}<br>{{ $t('peixesAquarioInstitucional.paragrafo7b') }}
                    </p>
                  </div>
                </div>
                <div class="carousel-item ">
                  <img src="../../../assets/institucional/img/galeria/galeria-aquario-4.jpg" class="d-block w-100" alt="...">
                  <div class="carousel-caption d-none d-md-block">
                    <p class="text-start">
                      {{ $t('peixesAquarioInstitucional.paragrafo8') }}<br>{{ $t('peixesAquarioInstitucional.paragrafo8b') }}
                    </p>
                  </div>
                </div>
                <div class="carousel-item ">
                  <img src="../../../assets/institucional/img/galeria/galeria-aquario-5.jpg" class="d-block w-100" alt="...">
                  <div class="carousel-caption d-none d-md-block">
                    <p class="text-start">
                      {{ $t('peixesAquarioInstitucional.paragrafo9') }}<br>{{ $t('peixesAquarioInstitucional.paragrafo9b') }}
                    </p>
                  </div>
                </div>galeria-especie-mar2
                <div class="carousel-item ">
                  <img src="../../../assets/institucional/img/galeria/galeria-aquario-6.jpg" class="d-block w-100" alt="...">
                  <div class="carousel-caption d-none d-md-block">
                    <p class="text-start">
                      {{ $t('peixesAquarioInstitucional.paragrafo10') }}<br>{{ $t('peixesAquarioInstitucional.paragrafo10b') }}
                    </p>
                  </div>
                </div>
                <div class="carousel-item ">
                  <img src="../../../assets/institucional/img/galeria/galeria-especie-mar2.jpg" class="d-block w-100" alt="...">
                  <div class="carousel-caption d-none d-md-block">
                    <p class="text-start">
                      {{ $t('peixesAquarioInstitucional.paragrafo11') }}<br>{{ $t('peixesAquarioInstitucional.paragrafo11b') }}
                    </p>
                  </div>
                </div>
              </div>
              <button class="carousel-control-prev" type="button" data-bs-target="#carousel-especies" data-bs-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="visually-hidden">{{ $t('label.anterior') }}</span>
              </button>
              <button class="carousel-control-next" type="button" data-bs-target="#carousel-especies" data-bs-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="visually-hidden">{{ $t('label.próximo') }}</span>
              </button>
            </div><!--/ galeria -->
        </div>
      </div>
      <EspeciesForm v-if="viewEspecie" :speciesId="species.species_id" :viewEspecie="true" :byInstitucional="true"/>
      <Especies v-else :withFilter="false" :withPageTitle="false" :withOrderBy="true" :byInstitucional="true" @actionByInstitucional="actionByInstitucional" :dataFilter="{ species_type: 1, kingdom_id: 1, economic_use_id: 25, class_id: 1 }"/>
      <div class="row mb-2 mb-xl-3">
        <div class="col-auto ml-auto text-right mt-n1">
          <button v-if="viewEspecie" @click="viewEspecie=false" class="btn bt-filtrar mt-1 mb-2">
            {{ $t('label.exibirListagem') }}
          </button>
        </div>
      </div>
      <InstitucionalSliderTemas />
    </div>
  </div>
</template>

<script>
import Especies from '../../admin/especies/Especies.vue'
import EspeciesForm from '../../admin/especies/EspeciesForm.vue'
import InstitucionalSliderTemas from '@/components/institucional/InstitucionalSliderTemas'
export default {
  name: 'PeixesAquarioInstitucional',
  components: { Especies, EspeciesForm, InstitucionalSliderTemas },
  data () {
    return {
      driver: null,
      viewEspecie: false,
      species: {}
    }
  },
  methods: {
    actionByInstitucional: function (item) {
      this.species = item
      this.viewEspecie = true
    }
  },
  created () {
    this.viewEspecie = false
  }
}
</script>
